import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 가격 정보 ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 직전 투자가 ")

import {PropType, toRefs, computed} from 'vue'
import {AgBoxS, AgIconS} from '@/components/ag'
import {PriceItem} from './PriceInfoTypes'
import {currency, numberToKorean} from '@/utils/filters'


export default /*#__PURE__*/_defineComponent({
  props: {
  previousInvestmentPrice: {default: 0, type: Number},
  priceList: {default: () => ([]), type: Array as PropType<PriceItem[]>},
  stockPriceTotal: {default: 0, type: Number},
},
  setup(__props) {

const props = __props



const {previousInvestmentPrice, stockPriceTotal, priceList} = toRefs(props)

const previousInvestmentPriceRef = computed(() => currency(previousInvestmentPrice.value))
const stockPriceTotalRef = computed(() => numberToKorean(stockPriceTotal.value))
const priceListRef = computed(() => priceList.value.map((value: PriceItem) => {
  const {price = '정보 없음', name} = value
  
  return {name, price: price ? currency(price) : '정보 없음'}
}))

const hasPriceList = computed(() => {
  return Boolean(priceList.value.length)
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(AgBoxS), { css: {bg: 'white', dp: 'flex', direction: 'column', alignItems: 'stretch', p: 20} }, {
    default: _withCtx(() => [
      _createVNode(_unref(AgBoxS), { css: {typography: 'tit18b', grow: 1} }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), { css: {dp: 'flex', mt: 8} }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgBoxS), { css: {typography: 'main14r', color: 'gray3', grow: 1} }, {
            default: _withCtx(() => [
              _hoisted_2
            ]),
            _: 1
          }),
          _createVNode(_unref(AgBoxS), { css: {typography: 'main14r'} }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(previousInvestmentPriceRef)) + " 원 ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_unref(AgBoxS), { css: {bg: 'bg1', corner: 4, dp: 'flex', alignItems: 'center', px: 8, py: 4, alignSelf: 'flex-end'} }, {
        default: _withCtx(() => [
          _createVNode(_unref(AgIconS), {
            css: {width: 12, height: 12, color: 'gray3', mr: 4},
            name: "businessOutline"
          }),
          _createVNode(_unref(AgBoxS), { css: {typography: 'main12r', color: 'gray3'} }, {
            default: _withCtx(() => [
              _createTextVNode(" 시총 " + _toDisplayString(_unref(stockPriceTotalRef)) + " 억원 상당 ", 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_unref(hasPriceList))
        ? (_openBlock(), _createBlock(_unref(AgBoxS), { key: 0 }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(priceListRef), (item) => {
                return (_openBlock(), _createBlock(_unref(AgBoxS), {
                  key: item.name,
                  css: {dp: 'flex', mt: 8}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(AgBoxS), { css: {grow: 1, color: 'gray3'} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.name), 1)
                      ]),
                      _: 2
                    }, 1024),
                    _createVNode(_unref(AgBoxS), null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(item.price) + " 원 ", 1)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
              }), 128))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})